module.exports = __webpack_public_path__ + "static/media/forgot-password.67a3ddb0.png";